import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../api/apiService';
import './Dashboard.css';

interface DashboardStats {
  total_distributors: number;
  pending_approvals: number;
  total_orders: number;
  total_users: number;
  total_drivers: number;
  total_products: number;
}

const statCards: { key: keyof DashboardStats; label: string; icon: string; color: string; path: string }[] = [
  { key: 'total_distributors', label: 'Total Distributors', icon: '👥', color: 'blue', path: '/distributors' },
  { key: 'pending_approvals', label: 'Pending Approvals', icon: '⏳', color: 'orange', path: '/distributors?status=pending_approval' },
  { key: 'total_users', label: 'Total Users', icon: '👤', color: 'purple', path: '/users' },
  //{ key: 'total_drivers', label: 'Total Drivers', icon: '🚚', color: 'teal', path: '/drivers' },
  { key: 'total_orders', label: 'Total Orders', icon: '📦', color: 'green', path: '/orders' },
  { key: 'total_products', label: 'Total Products', icon: '🫙', color: 'indigo', path: '/products' },
];

const Dashboard: React.FC = () => {
  const [stats, setStats] = useState<DashboardStats>({
    total_distributors: 0,
    pending_approvals: 0,
    total_orders: 0,
    total_users: 0,
    total_drivers: 0,
    total_products: 0,
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const loadStats = async () => {
    setLoading(true);
    try {
      const { data } = await apiService.get('/admin/dashboard');
      setStats(data);
    } catch (error) {
      console.error('Error loading stats:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStats();
  }, []);

  if (loading) {
    return <div className="dashboard-loading">Loading...</div>;
  }

  return (
    <div className="dashboard-content">
      <div className="dashboard-header">
        <div className="dashboard-header-row">
          <h2 className="dashboard-title">Overview</h2>
          <button type="button" className="dashboard-refresh" onClick={loadStats}>
            Refresh
          </button>
        </div>
        <p className="dashboard-subtitle">Key counts across distributors, users, drivers, orders and products</p>
      </div>
      <div className="stats-grid">
        {statCards.map(({ key, label, icon, color, path }) => (
          <button
            key={key}
            type="button"
            className={`stat-card stat-card--${color} ${path === '#' ? 'stat-card--static' : ''}`}
            onClick={() => path !== '#' && navigate(path)}
          >
            <div className={`stat-icon stat-icon--${color}`}>{icon}</div>
            <div className="stat-info">
              <h3>{stats[key]}</h3>
              <p>{label}</p>
            </div>
          </button>
        ))}
      </div>
      <div className="dashboard-sections">
        <div className="section-card">
          <h2>Quick Actions</h2>
          <div className="action-buttons">
            <button type="button" className="action-btn" onClick={() => navigate('/distributors')}>
              Manage Distributors
            </button>
            <button type="button" className="action-btn" onClick={() => navigate('/orders')}>
              View Orders
            </button>
            <button type="button" className="action-btn" onClick={() => navigate('/settings')}>
              Settings
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
